import { memo } from "react";
import { BaseEdge, useReactFlow } from "reactflow";
import { useSelector } from "react-redux";

const StraightEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style = {},
  markerEnd
}) => {
  const { getEdge, getNode } = useReactFlow();
  const edge = getEdge(id);
  const edgeSourceNode = getNode(edge.source);
  const nodeHeight = edgeSourceNode?.height || 54;
  const nodeWidth = edgeSourceNode?.width || 150;
  const { isVerticalCanvasDirection } = useSelector((store) => store?.designer?.settings);

  const adjustedSourceX = isVerticalCanvasDirection
    ? sourceX - nodeWidth / 2
    : sourceX - nodeWidth / 2 - 4;
  const adjustedSourceY = isVerticalCanvasDirection
    ? sourceY - nodeHeight / 2 - 4
    : sourceY + nodeHeight / 2;

  const edgePath = `M${adjustedSourceX},${adjustedSourceY} L${targetX},${targetY}`;

  return <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />;
};

export default memo(StraightEdge);
